<template>
  <div class="wheel-battle-consumer-match-tab">
    <div v-if="waitingTeams.length" class="waiting-bar">
      <span class="waiting-label">候场：</span>
      <div class="waiting-teams">
        <div
          v-for="team in waitingTeams"
          :key="team.id || team.name"
          class="waiting-team"
        >
          <img
            v-if="getTeamLogoUrl(team, 20, 20)"
            class="waiting-logo"
            :src="getTeamLogoUrl(team, 20, 20)"
            alt=""
          />
          <div v-else class="waiting-logo waiting-logo-placeholder" />
          <span class="waiting-name overflow-text">{{ team.name }}</span>
        </div>
      </div>
    </div>

    <div v-if="!matchList.length" class="empty-state">暂无对战记录</div>

    <div
      v-for="item in matchList"
      :key="item.id"
      class="match-card"
    >
      <div class="match-card-head">
        <span class="match-label">{{ item.label }}</span>
        <span
          class="status-tag"
          :class="item.status === 'inProgress' ? 'status-in-progress' : 'status-completed'"
        >{{ item.statusLabel }}</span>
      </div>
      <div class="match-card-body">
        <div class="match-side">
          <div v-if="item.timeText" class="side-time">{{ item.timeText }}</div>
          <div v-if="item.fieldName" class="side-field">{{ item.fieldName }}</div>
        </div>
        <div class="match-center">
          <div class="versus-team">
            <img
              v-if="getTeamLogoUrl(item.homeTeam, 24, 24)"
              class="team-logo"
              :src="getTeamLogoUrl(item.homeTeam, 24, 24)"
              alt=""
            />
            <div v-else class="team-logo team-logo-placeholder" />
            <div class="team-name overflow-text">{{ item.homeTeam.name }}</div>
          </div>
          <div class="versus-team">
            <img
              v-if="getTeamLogoUrl(item.awayTeam, 24, 24)"
              class="team-logo"
              :src="getTeamLogoUrl(item.awayTeam, 24, 24)"
              alt=""
            />
            <div v-else class="team-logo team-logo-placeholder" />
            <div class="team-name overflow-text">{{ item.awayTeam.name }}</div>
          </div>
        </div>
        <div v-if="item.status === 'completed'" class="match-score">
          <div
            class="score-item"
            :class="{ 'score-win': isWinSide(item, 'home') }"
          >{{ formatScore(item.homeScore) }}</div>
          <div
            class="score-item"
            :class="{ 'score-win': isWinSide(item, 'away') }"
          >{{ formatScore(item.awayScore) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveTeamLogoUrl } from '@/views/match-manage/wheel-battle/utils/team-logo'

export default {
  name: 'WheelBattleConsumerMatchTab',
  props: {
    matchLogo: {
      type: String,
      default: ''
    },
    waitingTeams: {
      type: Array,
      default: function () {
        return []
      }
    },
    matchList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    getTeamLogoUrl: function (team, width, height) {
      return resolveTeamLogoUrl(team, this.matchLogo, width, height)
    },
    formatScore: function (score) {
      if (score == null || score === '' || Number(score) === -1) {
        return '-'
      }
      return String(score)
    },
    isWinSide: function (item, side) {
      var home = Number(item.homeScore)
      var away = Number(item.awayScore)
      if (Number.isNaN(home) || Number.isNaN(away) || home === away) {
        return false
      }
      return side === 'home' ? home > away : away > home
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-consumer-match-tab {
  padding: 12px;
  background: #fff;
  min-height: 240px;
}

.waiting-bar {
  display: flex;
  align-items: center;
  width: 351px;
  height: 33px;
  margin: 0 auto 12px;
  padding: 0 12px;
  box-sizing: border-box;
  background: #e6edf4;
  border-radius: 22px;
}

.waiting-label {
  flex-shrink: 0;
  margin-right: 8px;
  font-size: 12px;
  color: #303133;
}

.waiting-teams {
  flex: 1;
  display: flex;
  min-width: 0;
  overflow: hidden;
}

.waiting-team {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;

  & + & {
    margin-left: 12px;
  }
}

.waiting-logo {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
}

.waiting-logo-placeholder {
  background: #d9d9d9;
}

.waiting-name {
  font-size: 12px;
  color: #73767a;
}

.empty-state {
  padding: 48px 16px;
  text-align: center;
  font-size: 14px;
  color: #909399;
}

.match-card {
  // margin-bottom: 12px;
  padding: 12px;
  background: #fff;
  border-radius: 8px;
  border-bottom: 1px solid #EEEEEE;

  &:last-child {
    margin-bottom: 0;
  }
}

.match-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.match-label {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.status-tag {
  padding: 1px 6px;
  font-size: 11px;
  line-height: 16px;
  border-radius: 2px;
}

.status-in-progress {
  color: #e85d5d;
  background: #fdeeee;
}

.status-completed {
  color: #529b2e;
  background: #eef7ea;
}

.match-card-body {
  display: flex;
  align-items: center;
}

.match-side {
  width: 52px;
  flex-shrink: 0;
  color: #337ecc;
  font-size: 12px;
  line-height: 18px;
}

.side-time {
  font-weight: 600;
}

.side-field {
  margin-top: 2px;
  color: #73767a;
  font-size: 11px;
}

.match-center {
  flex: 1;
  min-width: 0;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
}

.versus-team + .versus-team {
  margin-top: 10px;
}

.versus-team {
  display: flex;
  align-items: center;
  min-width: 0;
}

.team-logo {
  margin-right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
}

.team-logo-placeholder {
  background: #d9d9d9;
}

.team-name {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #73767a;
}

.match-score {
  width: 36px;
  flex-shrink: 0;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.score-item + .score-item {
  margin-top: 10px;
}

.score-item {
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: #909399;
  border-radius: 3px;
}

.score-win {
  color: #337ecc;
  background: #ecf5ff;
}

.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
